import { reducers } from 'redux/core'
import request from 'sb-request'


const fetch = () =>
  request.get('rest/user/ratedperfumes')
  // TODO change `perfumes` to `items`
    .then(({ perfumes: items }) => {
      if (items) {
        reducers.models.ratedFragrances.set(items)
      }
    })


export default {
  fetch,
}
